export class ResponseGoogleRecaptchaVM {
  success: boolean | null;
  challenge_ts: Date | null;
  hostname: string | null;
  score: number | null;
  action: string | null;
  error_codes: string[] | null;
  constructor() {
    this.success = false;
    this.challenge_ts = null;
    this.hostname = null;
    this.score = null;
    this.action = null;
    this.error_codes = null;
  }
}